import React from 'react';
import moment from 'moment';
import {
  InputNumber, Radio, Button, Select, DatePicker, Input,
} from 'antd';
import { ValueModifier, ValueSelect } from './styles';
import {
  MODIFIER_MAP, VALUE_MAP, DISPLAY_VALUE_MAP, INCREASE, DECREASE, SET, TYPES,
  TIME_FORMAT, DATE_FORMAT, DATETIME_FORMAT, FORMAT_MAP,
} from '../../constants/grid.constants';

class ValueEditor extends React.Component {
  constructor(props) {
    super(props);
    const { dataType, setOnly } = this.props;
    this.state = {
      modify: {
        modification: SET,
        modifier_unit: !setOnly && MODIFIER_MAP[dataType][0],
      },
    };
  }

  getEdit = (isSetting) => {
    const {
      modify: {
        value, displayValue, modifier_unit, modification,
      },
    } = this.state;
    const { dataType } = this.props;

    const durationAppend = v => dataType === 'duration' ? `${v}:00` : v;

    // A small hack to ignore TZ, so that it is always the datetime that is assigned without
    // been affected by TZ. This hack is made to inline with Bkt-React changes due to it does not
    // support moment-timezone, which cannot set the tz default in Bkt-React, but Antd requires TZ.
    // for correct display.
    const useNoTZValue = (dataType === 'datetime' && displayValue) && (displayValue);

    return isSetting
      ? {
        modification, displayValue, value: durationAppend(useNoTZValue || value), modifier_unit: 'number',
      }
      : {
        modification, displayValue, value: parseInt(useNoTZValue || value, 0), modifier_unit,
      };
  }

  onModify = (type, val, dataType) => {
    const { modify: { value, modifier_unit, modification } } = this.state;
    const modify = {
      ...{ modifier_unit, modification },
      [type]: val,
    };

    if (!type === 'modification') {
      modify.value = value;
    }

    if (DISPLAY_VALUE_MAP[dataType] && modify.modification === 'set') {
      modify.displayValue = DISPLAY_VALUE_MAP[dataType](moment(modify.value));
    }

    return this.setState({ modify });
  }

  renderInput = ({ dataType, props }) => {
    const { modify: { value } } = this.state;
    switch (dataType) {
      case TYPES.boolean:
        return (
          <Radio.Group
            onChange={({ target }) => this.onModify('value', target.value, dataType)}
          >
            <Radio value="true">True</Radio>
            <Radio value="false">False</Radio>
          </Radio.Group>
        );
      case TYPES.datetime:
        return (
          <DatePicker
            showTime={{ format: TIME_FORMAT }}
            format={DATETIME_FORMAT}
            value={value && moment(value)}
            {...props}
          />
        );
      case TYPES.date:
        return (
          <DatePicker
            format={DATE_FORMAT}
            value={value && (moment(value, DATE_FORMAT))}
            {...props}
          />
        );
      case TYPES.duration:
        return (
          <Input
            value={value}
            {...props}
            onChange={({ target }) => this.onModify('value', target.value, dataType)}
          />
        );
      case TYPES.time:
        return (
          <Input
            value={value}
            {...props}
            onChange={({ target }) => this.onModify('value', target.value, dataType)}
          />
        );
      case TYPES.string:
        return (
          <Input
            value={value}
            {...props}
            onChange={({ target }) => this.onModify('value', target.value, dataType)}
          />
        );
      default:
        return (
          <InputNumber
            value={value}
            {...props}
          />
        );
    }
  }

  render() {
    const {
      dataType, onSave, setOnly, displayName,
    } = this.props;
    const { modify } = this.state;
    const modifiers = MODIFIER_MAP[dataType];
    const isSetting = modify.modification === SET;
    const formatDisplay = FORMAT_MAP[dataType] || displayName;
    const disableRadioButtons = !setOnly && dataType !== 'boolean'
    return (
      <ValueSelect>
        <ValueModifier>
          {(disableRadioButtons)
            && (
              <Radio.Group
                value={modify.modification}
                onChange={({ target }) => this.onModify('modification', target.value, dataType)}
              >
                <Radio value={SET}>Set</Radio>
                <Radio value={INCREASE}>Up</Radio>
                <Radio value={DECREASE}>Down</Radio>
              </Radio.Group>
            )
          }

          <Input.Group compact>
            {this.renderInput({
              dataType: isSetting && dataType,
              props: {
                onChange: v => this.onModify('value', (v && isSetting) ? VALUE_MAP[dataType](v) : v, dataType),
                placeholder: isSetting ? `Enter ${formatDisplay}` : 'Offset amount',
                style: { width: isSetting ? '100%' : '60%' },
              },
            })}
            {!isSetting && (
              <Select defaultValue={modify.modifier_unit} style={{ width: '40%' }}>
                {modifiers
                  .map(option => (
                    <Select.Option
                      key={option}
                      value={option}
                      onClick={({ key }) => this.onModify('modifier_unit', key, dataType)}
                    >
                      {option}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </Input.Group>
        </ValueModifier>
        <Button
          block
          onClick={() => onSave(this.getEdit(isSetting))}
          disabled={(!modify.value && modify.value !== 0)}
        >
          OK
        </Button>
      </ValueSelect>
    );
  }
}

export default ValueEditor;
